<app-menu-common url="sales"></app-menu-common>

<div class="um-page">
  <div class="flexrow um-header">
    <h2>Gestion des utilisateurs</h2>
    @if (unlocked()) {
      <span class="page-hint">{{ users().length }} utilisateur{{ users().length > 1 ? 's' : '' }} — cliquez une ligne pour la modifier.</span>
    }
    <span class="spacer"></span>
    @if (unlocked()) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="um-filter">
        <mat-label>Recherche (nom, prénom, identifiant, e-mail)</mat-label>
        <input matInput autocomplete="off" [value]="filter()" (input)="onFilter($event)" />
      </mat-form-field>
      <button mat-flat-button color="primary" type="button" id="newuserbutton" [disabled]="busy()" (click)="newUser()"><mat-icon>person_add</mat-icon>&nbsp;Nouvel utilisateur</button>
      <button mat-stroked-button type="button" id="lockbutton" [disabled]="busy()" (click)="lock()"><mat-icon>lock</mat-icon>&nbsp;Verrouiller</button>
    }
  </div>

  @if (cleartextWarning) {
    <div class="um-warn" role="alert"><mat-icon>warning</mat-icon>Connexion non chiffrée : les mots de passe traversent le réseau en clair.</div>
  }

  @if (!unlocked()) {
    <form class="um-lock" (ngSubmit)="unlock(ownpw)">
      <input type="text" name="username" autocomplete="username" [value]="login" hidden readonly />
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="um-lock-field">
        <mat-label>Votre mot de passe</mat-label>
        <input matInput #ownpw type="password" name="current-password" autocomplete="current-password" spellcheck="false" />
      </mat-form-field>
      <button mat-flat-button color="primary" type="submit" id="unlockbutton" [disabled]="busy()"><mat-icon>lock_open</mat-icon>&nbsp;Déverrouiller</button>
      <span class="page-hint">Le serveur le revérifie à chaque envoi ; l'écran l'oublie après 5 minutes sans appel réussi.</span>
    </form>
  } @else {
    @if (draft(); as d) {
      <form #editor class="um-editor" autocomplete="off" (ngSubmit)="save()">
        <div class="um-editor-title">
          {{ d.id == null ? 'Nouvel utilisateur' : 'Utilisateur n° ' + d.id }}
          @if (d.id === SUPER_USER_ID) {
            <span class="super-chip">super utilisateur</span>
          }
        </div>

        <div class="um-fields">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-store">
            <mat-label>Magasin</mat-label>
            <mat-select #firstField name="store" required [ngModel]="d.store" (ngModelChange)="patch('store', $event)">
              @for (s of stores(); track s.id) {
                <mat-option [value]="s.id">{{ s.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-name">
            <mat-label>Nom *</mat-label>
            <input matInput name="lastname" maxlength="100" [ngModel]="d.lastname" (ngModelChange)="patch('lastname', $event)" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-name">
            <mat-label>Prénom</mat-label>
            <input matInput name="firstname" maxlength="100" [ngModel]="d.firstname" (ngModelChange)="patch('firstname', $event)" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-login">
            <mat-label>{{ d.id === SUPER_USER_ID ? "Identifiant *" : "Identifiant (vide = pas d'accès, mot de passe effacé)" }}</mat-label>
            <input matInput name="login" maxlength="64" autocapitalize="off" autocorrect="off" spellcheck="false" [ngModel]="d.login" (ngModelChange)="patch('login', $event)" />
          </mat-form-field>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-email">
            <mat-label>E-mail</mat-label>
            <input matInput name="email" inputmode="email" maxlength="254" autocapitalize="off" autocorrect="off" spellcheck="false" [ngModel]="d.email" (ngModelChange)="patch('email', $event)" />
          </mat-form-field>
        </div>
        @if (passwordWipeWarning()) {
          <span class="um-note um-note-warn" role="alert">Sans identifiant, ce compte perd l'accès : son mot de passe actuel sera effacé à l'enregistrement.</span>
        }

        <div class="um-checks">
          <div class="um-group">
            <span class="um-group-title">Habilitations</span>
            @for (h of habilitationChoices(); track h.id) {
              <mat-checkbox [checked]="d.habilitations.includes(h.id) || isLockedAdmin(d, h)" [disabled]="isLockedAdmin(d, h)" (change)="toggle('habilitations', h.id, $event.checked)">{{ h.name }}</mat-checkbox>
            } @empty {
              <span class="um-note">Référentiel des habilitations indisponible.</span>
            }
          </div>
          <div class="um-group">
            <span class="um-group-title">Rôles métier</span>
            @for (r of roleChoices(); track r.id) {
              <mat-checkbox [checked]="d.roles.includes(r.id)" (change)="toggle('roles', r.id, $event.checked)">{{ r.name }}{{ r.active ? '' : ' (inactif)' }}</mat-checkbox>
            } @empty {
              <span class="um-note">Référentiel des rôles indisponible.</span>
            }
            @if (minimalFileNote()) {
              <span class="um-note">Une fiche salarié minimale sera créée.</span>
            }
          </div>
        </div>

        <div class="um-password">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="f-password">
            <mat-label>Mot de passe (en clair, vide = inchangé)</mat-label>
            <input matInput type="text" name="cleartext" autocomplete="off" spellcheck="false" autocapitalize="off" autocorrect="off" [ngModel]="d.password" (ngModelChange)="patch('password', $event)" />
          </mat-form-field>
          <button mat-stroked-button type="button" id="generatepasswordbutton" (click)="generate()"><mat-icon>casino</mat-icon>&nbsp;Générer</button>
          <span class="um-note">{{ passwordMinOf(d) }} à {{ PASSWORD_MAX }} caractères, envoyé tel quel (ni rogné ni modifié).</span>
          @if (hasOuterSpaces(d.password)) {
            <span class="um-note um-note-warn">Espaces en début ou en fin : ils font partie du mot de passe.</span>
          }
        </div>

        <div class="um-actions">
          <button mat-flat-button color="primary" type="submit" id="saveuserbutton" [disabled]="busy() || isSuperUserLocked(d)"><mat-icon>save</mat-icon>&nbsp;Enregistrer</button>
          <button mat-button type="button" (click)="cancel()">Annuler</button>
          @if (isSuperUserLocked(d)) {
            <span class="um-note um-note-warn">Le compte 1 ne se modifie que depuis le compte 1.</span>
          } @else if (d.id != null && d.id === myId) {
            <span class="um-note">Changer votre propre identifiant impose de se reconnecter.</span>
          }
        </div>
      </form>
    }

    <div class="um-table-wrap">
      <table class="um-table">
        <thead>
          <tr>
            <th class="num">Id</th>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Identifiant</th>
            <th>Magasin</th>
            <th>E-mail</th>
            <th>Habilitations</th>
            <th>Rôles métier</th>
            <th>Fiche salarié</th>
            <th>Mot de passe</th>
          </tr>
        </thead>
        <tbody>
          @for (v of shown(); track v.row.id) {
            <tr tabindex="0" [class.selected]="v.row.id === selectedId()" [attr.aria-disabled]="busy() || null" (click)="pick(v.row)" (keydown.enter)="pick(v.row)">
              <td class="num">{{ v.row.id }}</td>
              <td class="strong">
                {{ v.row.lastname }}
                @if (v.row.id === SUPER_USER_ID) {
                  <span class="super-chip">super utilisateur</span>
                }
              </td>
              <td>{{ v.row.firstname }}</td>
              <td class="nowrap">{{ v.row.login ?? '—' }}</td>
              <td>{{ v.storeName }}</td>
              <td class="email">{{ v.row.email }}</td>
              <td>{{ v.habilitationLabels }}</td>
              <td>{{ v.roleLabels }}</td>
              <td class="nowrap" [class.muted]="v.employeeLabel !== 'Oui'">{{ v.employeeLabel }}</td>
              <td class="nowrap" [class.pw-legacy]="v.row.password_state === 'legacy'" [class.muted]="v.row.password_state === 'none'">{{ v.passwordLabel }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="10" class="um-empty">{{ users().length ? 'Aucun utilisateur ne correspond à la recherche.' : 'Aucun utilisateur.' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
